import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import MerchantDetails from '@/components/v2/network_distributor/MerchantDetails.vue';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import Orders from '@/components/v2/ecommerce/OrderHistory';
import Paginator from '@/components/v2/Paginator.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { PER_PAGE } from '@/helpers/constants/app';
let MerchantOrderHistory = class MerchantOrderHistory extends Mixins(ViewportSizeMixin) {
    get merchantUuid() {
        return this.$route.params.merchantUuid;
    }
    get headers() {
        return [
            {
                text: 'REFERENCE ID',
                value: 'transactionNumber',
                align: 'left',
                sortable: false,
                isCurrentcy: false,
            },
            {
                text: 'PRODUCT PHOTO',
                value: 'productPhoto',
                align: 'left',
                sortable: false,
                isCurrentcy: false,
            },
            {
                text: 'PRODUCT NAME',
                value: 'productName',
                align: 'left',
                sortable: false,
                isCurrentcy: false,
            },
            {
                text: 'CUSTOMER NAME',
                value: 'customerName',
                align: 'left',
                sortable: false,
                isCurrentcy: false,
            },
            {
                text: 'AMOUNT',
                value: 'amount',
                align: 'left',
                sortable: false,
                isCurrentcy: true,
            },
            {
                text: 'PAYMENT METHOD',
                value: 'customerName',
                align: 'left',
                sortable: false,
                isCurrentcy: false,
            },
            {
                text: 'ORDER DATE',
                value: 'date',
                align: 'left',
                sortable: false,
                isCurrentcy: false,
            },
        ];
    }
    displayPaginator(total) {
        return total > PER_PAGE;
    }
};
MerchantOrderHistory = __decorate([
    Component({
        components: {
            AppBasicDetails,
            MerchantDetails,
            Orders,
            Paginator,
        },
    })
], MerchantOrderHistory);
export default MerchantOrderHistory;
